import { Component, Input } from '@angular/core';
import { environment } from '../../../environments/environment';
import { decodeBase64ToText, encodeToBase64 } from '../../utility';
import { KanbanService } from '../kanban.service';

@Component({
  selector: 'app-kanban-column',
  templateUrl: './kanban-column.component.html',
  styleUrl: './kanban-column.component.css',
})
export class KanbanColumnComponent {
  // checkbox status
  notStarted: boolean = true;
  ongoing: boolean = true;
  completed: boolean = true;
  delayed: boolean = true;
  terminated: boolean = true;
  kanban: any = {}; // Adjust the type as needed
  @Input() kanbanPayload: any = {};
  @Input() selQuater: any;
  @Input() category: any = 'member';
  @Input() notstartedData: any = [];
  @Input() ongoingData: any = [];
  @Input() completedData: any = [];
  @Input() delayedData: any = [];
  @Input() terminatedData: any = [];

   @Input() notStartedCount: number=0;
   @Input() ongoingCount: number=0;
   @Input() completedCount: number=0;
   @Input() delayedCount: number=0;
  @Input()  terminatedCount: number=0;
  kanbanUrl:any
  payloadData: any = {};
  ngOnInit() {
    this.kanbanUrl = `${environment.opbBackendHost}/api/${this.category}/dashboard/kanban`;
    const { outcome_status, ...remainingData } = this.kanbanPayload;
    this.payloadData = { ...remainingData,outcome_status:'1'};
  }

  constructor() {}

  onDataLoaded(data: any[], type: string) {
    if (type == 'notstarted') {
      this.notstartedData = data;
    }
    if (type == 'ongoing') {
      this.ongoingData = data;
    }
    if (type == 'completed') {
      this.completedData = data;
    }
    if (type == 'delayed') {
      this.delayedData = data;
    }
    if (type == 'terminated') {
      this.terminatedData = data;
    }
  }
}
